module.exports = __webpack_public_path__ + "static/media/bttn_radio_esculab.12970354.svg";